import { transactionStateLabel } from '../../utils/display_names'
import { formatTimeString } from '../../utils/formatters'
import BaseExporter from './base_exporter'

export default class UserTxCSVExporter extends BaseExporter {
  /**
   * data export logic for user transactions
   * @return Array formatted dataset
   */
  export() {
    // prepare data
    const txIdentityFields = ['client_guid', 'first_name', 'last_name', 'country_code']
    const txFields = ['created', 'updated', 'state']

    const data = this.data.map((entry) => {
      let dataRow = []
      if (!entry) {
        return new Array(this.header.length)
      }
      if (entry.hasOwnProperty('transaction_identity') && entry.transaction_identity) {
        for (let i = 0; i < txIdentityFields.length; i++) {
          if (entry.transaction_identity.hasOwnProperty(txIdentityFields[i])) {
            dataRow.push(entry.transaction_identity[txIdentityFields[i]])
          } else {
            dataRow.push(null)
          }
        }
      } else {
        txIdentityFields.map(() => dataRow.push(null))
      }
      for (let i = 0; i < txFields.length; i++) {
        if (entry.hasOwnProperty(txFields[i]) && entry[txFields[i]]) {
          if (txFields[i] === 'state') {
            dataRow.push(transactionStateLabel(entry[txFields[i]]))
          } else {
            dataRow.push(formatTimeString(entry[txFields[i]]))
          }
        } else {
          dataRow.push(null)
        }
      }
      if (entry.hasOwnProperty('transaction_identity') && entry.transaction_identity) {
        if (entry.transaction_identity.hasOwnProperty('is_accredited_investor')) {
          dataRow.push(entry.transaction_identity.is_accredited_investor.toString())
        } else {
          dataRow.push(null)
        }

        dataRow.push(entry.transaction_identity.accredited_investor_status || null)
      } else {
        let i = 0
        while (i < 2) {
          dataRow.push(null)
          i++
        }
      }

      return dataRow
    })
    data.unshift(this.header)
    return data
  }
}
